<template>
  <div class="content">
    <div class="card">
      <div class="card-address" @click="pickaddess">
        <div v-if="!Province" class="address-nocon" >请选择您的地址</div>
        <div v-if="Province" class="address-con" >{{Province}}{{City}}{{District}}</div>
        <img :src="public_path + '/static/images/arrow_right.svg'" alt="">
      </div>
      <div class="address-detail">
        <div class="address-detail-title">详细地址</div>
        <div class="address-detail-con">
          <textarea placeholder="街道、楼牌号等" v-model="address"></textarea>
        </div>
      </div>
    </div>
    <button class="save-btn" @click="saveaddress">保存</button>
    <!-- 居住地址三级联动选项 -->
    <div class="showChose" v-if="showChose && info.length">
      <div class="address">
        <div class="title">
          <span></span>
          <h4>选择省市区</h4>
          <span @click="closeAdd()">×</span>
        </div>
        <div class="title">
          <div class="area" @click="provinceSelected()">{{Province ? Province : info[province - 1].name}}</div>
          <div class="area" @click="citySelected()" :class="City ? '' : 'active'">{{City ? City : '请选择'}}</div>
          <div class="area" @click="districtSelected()" :class="District?'':'active'" v-show="City">{{District ? District : '请选择'}}</div>
        </div>
        <ul class="address-list">
          <li class="addList" v-for="(v,k) in info" :key="v.id" @click="getProvinceId(v.id, v.name, k)" v-show="showProvince" :class="v.selected ? 'active' : ''">{{v.name}}</li>
          <li class="addList" v-for="(v,k) in showCityList" :key="v.id" @click="getCityId(v.id, v.name, k)" v-show="showCity" :class="v.selected ? 'active' : ''">{{v.name}}</li>
          <li class="addList" v-for="(v,k) in showDistrictList" :key="v.id" @click="getDistrictId(v.id, v.name, k)" v-show="showDistrict" :class="v.selected ? 'active' : ''">{{v.name}}</li>
        </ul>
      </div>
    </div>
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="massage"></dialog-item>
    </div>
  </div>
</template>
<script>
import { getCities } from '@/http/api'
import dialogItem from '@/components/dialog'

export default {
  data () {
    return {
      public_path: process.env.PUBLICK_PATH,
      showChose: false,
      showProvince: true,
      showCity: false,
      showDistrict: false,
      showCityList: false,
      showDistrictList: false,
      province: 5,
      city: 3,
      district: 57,
      GetProvinceId: 2,
      District: null,
      Province: null,
      City: null,
      // v-for循环判断是否为当前
      selected: false,
      info: [],
      address: '',
      showDialog: false
    }
  },
  components: {
    'dialog-item': dialogItem
  },
  methods: {
    getCities () {
      getCities({token: localStorage.token}).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.info = res.data
        }
      })
    },
    saveaddress () {
      if (!this.Province || !this.City || !this.District) {
        this.showDia('请选择收货地址')
      } else if (!this.address) {
        this.showDia('请填写具体地址信息')
      } else {
        let address = {
          province: this.Province,
          city: this.City,
          district: this.District,
          address: this.address
        }
        sessionStorage.setItem('address', JSON.stringify(address))
        this.$router.back(-1)
      }
    },
    showDia (massage) {
      this.showDialog = true
      this.massage = massage
      setTimeout(() => {
        this.showDialog = false
        this.massage = ''
      }, 1500)
    },
    pickaddess () {
      this.showChose = true
    },
    choseAdd () {
      this.showChose = true
    },
    closeAdd () {
      this.showChose = false
    },
    _filter (add, name, code) {
      let result = []
      for (let i = 0; i < add.length; i++) {
        if (code === add[i].id) {
          result = add[i][name]
        }
      }
      return result
    },
    getProvinceId (code, input, index) {
      this.province = code
      if (input === '上海' || input === '北京' || input === '天津' || input === '重庆') {
        this.Province = input
      } else {
        this.Province = input
      }
      this.showProvince = false
      this.showCity = true
      this.showDistrict = false
      this.showCityList = this._filter(this.info, 'list', this.province)
      // 点击选择当前
      this.info.map(a => (a.selected = false))
      this.info[index].selected = true
    },
    provinceSelected () {
      // 清除市级和区级列表
      this.showCityList = false
      this.showDistrictList = false
      // 清除市级和区级选项
      this.City = null
      this.District = null
      // 选项页面的切换
      this.showProvince = true
      this.showCity = false
      this.showDistrict = false
    },
    getCityId (code, input, index) {
      this.city = code
      this.City = input
      this.showProvince = false
      this.showCity = false
      this.showDistrict = true
      this.showDistrictList = this._filter(this.showCityList, 'list', this.city)
      // 选择当前添加active
      this.showCityList.map(a => (a.selected = false))
      this.showCityList[index].selected = true
    },
    citySelected () {
      this.showProvince = false
      this.showCity = true
      this.showDistrict = false
    },
    getDistrictId (code, input, index) {
      this.district = code
      this.District = input
      // 选择当前添加active
      this.showDistrictList.map(a => (a.selected = false))
      this.showDistrictList[index].selected = true
      // 选取市区选项之后关闭弹层
      this.showChose = false
    },
    districtSelected () {
      this.showProvince = false
      this.showCity = false
      this.showDistrict = true
    }
  },
  mounted () {
    let address = localStorage.address
    if (address) {
      address = JSON.parse(address)
      this.Province = address.province
      this.City = address.city
      this.District = address.district
      this.address = address.address
    }
    this.getCities()
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 .3rem;
  background: #f5f5f5;
  .card {
    background: #fff;
    border-radius: .16rem;
    margin-top: .3rem;
    .card-address {
      padding: 0 .3rem;
      height: 1.1rem;
      line-height: 1.1rem;
      font-size: .3rem;
      display: -webkit-flex;
      align-items: center;
      .address-nocon {
        flex: 1;
        color: rgba(51, 51, 51, 0.5);
      }
      .address-con {
        flex: 1;
      }
      img {
        width: .14rem;
        height: .25rem;
      }
    }
    .address-detail {
      padding: 0 .3rem;
      .address-detail-title {
        border-top: 1px solid #ebebeb;
        font-size: .28rem;
        line-height: .8rem;
      }
      .address-detail-con {
        textarea {
          resize:none;
          width: 100%;
          height: 2rem;
          outline: none;
          font-size: .28rem;
        }
      }
    }
  }
}
.save-btn {
  width: 6.90rem;
  height: .90rem;
  background: rgba(2, 179, 137, 1);
  border-radius: .45rem;
  margin-top: .3rem;
  color: #fff;
  font-size: .32rem;
}
.address {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 .3rem;
  box-sizing: border-box;
  z-index: 99;
  background:#fff;
}
.title {
  display: -webkit-flex;
  align-items: center;
}
.title span {
  flex: 1;
  text-align: right;
  font-size: 0.45rem;
  color :#D8D8D8;
}
.title h4 {
  flex: 3;
  text-align: center;
  font-size: 0.3rem;
  line-height: 0.88rem;
  font-weight: normal;
}
.area {
  display: inline-block;
  font-size: 0.24rem;
  line-height: 2;
  margin-right: 0.42rem;
  vertical-align: middle;
}
.address-list {
  margin-top: .2rem;
  padding-bottom: .2rem;
}
.addList {
  margin-top: .14rem;
  width: 100%;
  font-size: 0.30rem;
  line-height: 2;
}
/* 修改的格式 */
.address ul{
  width: 95%;
  height: 4rem;
  overflow-y: auto;
}

.address .title .active{
  color:#0071B8;
  border-bottom:0.02rem solid #0071B8;
}
.address ul .active{
  color:#0071B8;
}
</style>



// WEBPACK FOOTER //
// src/pages/address/Address.vue